import React from 'react';
import {useTranslation} from "react-i18next";

const OrderPaymentStatus = (props)=>{
    const { t } = useTranslation();

    let statusLabel = null;
    switch(props.status){
        case "OPEN":
            statusLabel = "primary";
            break;
        case "WAITING":
            statusLabel = "warning";
            break;
        case "PAID":
            statusLabel = "success";
            break;
        case "FAILURE":
            statusLabel = "danger";
            break;

    }
    return (
        <span className={"badge bg-" + statusLabel}>{t("models.order.payment_status." + props.status)}</span>
    )
}

export default OrderPaymentStatus;
